import { Box } from '@cdl/heartbeat-react';
import { useParams, Routes, Route } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorBoundary } from '../../../shared/error-boundary/error-boundary';
import { useClusterListener } from '../hooks/useClusterListener';
import { NavigationContext } from '../hooks/useNavigationRef';
import { clustersSelector } from '../selectors/cluster.selectors';
import { morphologiesSelector } from '../selectors/morphology.selectors';
import { loadClusters } from '../thunks/load-clusters.thunk';
import { Cleaning } from './Cleaning';
import { ClusteringHeader } from './ClusteringHeader';
import { DefaultView } from './DefaultView';
import { Merging } from './Merging';

export const Clustering: React.FC = () => {
  const { ecgId } = useParams();
  useClusterListener();
  const dispatch = useDispatch();
  const baseClusters = useSelector(clustersSelector);
  const morphologies = useSelector(morphologiesSelector);
  const navigationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (
      ecgId != null &&
      baseClusters.length === 0 &&
      morphologies.length === 0
    ) {
      dispatch(loadClusters(ecgId));
    }
  }, [ecgId, dispatch, baseClusters, morphologies]);

  if (ecgId == null) {
    return <></>;
  }

  return (
    <ErrorBoundary>
      <Box>
        <ClusteringHeader ecgId={ecgId} ref={navigationRef} />
        <NavigationContext.Provider value={navigationRef}>
          <Routes>
            <Route key='default' path='*' element={<DefaultView />} />
            <Route key='clean' path='/clean' element={<Cleaning />} />
            <Route key='merge' path='/merge' element={<Merging />} />
          </Routes>
        </NavigationContext.Provider>
      </Box>
    </ErrorBoundary>
  );
};
